// extracted by mini-css-extract-plugin
export default {"Badge":"ApiKeyLogs_Badge__x0Twl","text":"ApiKeyLogs_text__B7Gq-","error":"ApiKeyLogs_error__6jutz"};